import { MessagePartKind } from "models/enumerations/conversations/message-part-kind";
import ConversationMessageRecord from "models/view-models/conversations/conversation-message-record";
import { AnyMessagePartRecord } from "models/view-models/conversations/message-part-factory";
import React, { useMemo } from "react";
import SuggestedMemoryPart from "./suggested-memory-part";
import useFeatureFlags from "utilities/hooks/use-feature-flags";

interface MessagePartsProps {
    message: ConversationMessageRecord;
}

export interface BasePartComponentProps {
    messageId: string | undefined;
    part: AnyMessagePartRecord;
}

const MessageParts: React.FC<MessagePartsProps> = ({ message }) => {
    return (
        <>
            {message.parts.map((part, index) => (
                <MessagePart
                    key={part.partId ?? `part-${index}`}
                    messageId={message.id}
                    part={part}
                />
            ))}
        </>
    );
};

export default MessageParts;

const MessagePart: React.FC<{
    messageId: string | undefined;
    part: AnyMessagePartRecord;
}> = ({ messageId, part }) => {
    const { allowCasiMemories } = useFeatureFlags();

    const partTypeMap = useMemo(() => {
        return {
            [MessagePartKind.SuggestMemory]: allowCasiMemories
                ? SuggestedMemoryPart
                : undefined,
        };
    }, [allowCasiMemories]);

    if (part.kind == null) return null;
    const Component = partTypeMap[part.kind];

    if (!Component) return null;

    return <Component messageId={messageId} part={part} />;
};
